import { ChangeDetectionStrategy, Component } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { TeamsEntity } from 'gb-dashboard-data-access-team'
import { TeamsFacade } from 'libs/gb-dashboard/team/data-access/src/lib/+state/teams.facade'
import * as TeamsActions from 'libs/gb-dashboard/team/data-access/src/lib/+state/teams.actions'

@Component({
  selector: 'lib-gb-team-create-team-dialog',
  templateUrl: './gb-team-create-team-dialog.component.html',
  styleUrl: './gb-team-create-team-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbTeamCreateTeamDialogComponent {
  team = new FormControl('', [Validators.required])
  editCreateLoaded$ = this.teamsFacade.editCreateLoaded$
  count$ = this.teamsFacade.count$

  constructor(private teamsFacade: TeamsFacade) {}

  submit(count: number | null | undefined) {
    let order = +(count ?? 0) + 1
    if (!this.team.valid) return this.team.markAsTouched()

    const team = { name: this.team.value, order } as Partial<TeamsEntity>
    this.teamsFacade.dispatch(TeamsActions.createTeam({ team }))
  }
}
